var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: "打卡记录详情",
            visible: _vm.drawer,
            size: "600px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", { staticClass: "contract-body" }, [
            _c(
              "div",
              { staticClass: "mt20" },
              [
                _c("el-form", { attrs: { "label-width": "110px" } }, [
                  _c("div", { staticClass: "form-box" }, [
                    _c(
                      "div",
                      { staticClass: "form-item" },
                      [
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("姓名：")]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.info.card ? _vm.info.card.name : "--")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("部门：")]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                (_vm.info.frame && _vm.info.frame.name) || "--"
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("考勤组名称：")]
                          ),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.info.group || "--"))]),
                        ]),
                        _vm._v(" "),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("考勤日期：")]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$moment(_vm.info.created_at)
                                  .format("YYYY-MM-DD")
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("星期：")]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.getWeek(_vm.info.created_at))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("班次：")]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.getShift(_vm.info.shift_data))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("打卡时间：")]
                          ),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.info.created_at))]),
                        ]),
                        _vm._v(" "),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("打卡地址：")]
                          ),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.info.address))]),
                        ]),
                        _vm._v(" "),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("打卡备注：")]
                          ),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.info.remark || "--"))]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [_vm._v("打卡图片：")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.info.image, function (item, index) {
                              return _c("p", { key: index }, [
                                _c("img", {
                                  staticClass: "image",
                                  attrs: { src: item, alt: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.lookViewer(item, "")
                                    },
                                  },
                                }),
                              ])
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("image-viewer", {
        ref: "imageViewer",
        attrs: { "src-list": _vm.srcList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }